import * as VKTBridge from '@instant-messengers/vk-teams-bridge';
import { IS_MY_TEAM } from 'reactApp/appHelpers/configHelpers';

type VKTColorScheme = { colorsScheme: 'light' | 'dark' };

export const vkTeamsBridge = VKTBridge;

const VKTeamsMessages = {
    LoadingCompleted: 'LoadingCompleted',
    GetThemeSettings: 'GetThemeSettings',
} as const;

// TODO: См. sendVKTeamsMessageWithReliableAnswer
// const WAIT_RESPONSE_FROM_VKT_TIMEOUT = 1000;

function preventTransitionEffects(): () => void {
    document.body.classList.add('notransition');
    return () => {
        const _ = window.getComputedStyle(document.body).opacity;
        document.body.classList.remove('notransition');
    };
}

function sendVKTeamsMessageWithReliableAnswer<T>(message: keyof typeof VKTeamsMessages, args: Record<string, unknown>): Promise<T> {
    return Promise.race<T>([
        vkTeamsBridge.send(message, args),
        /**
         * TODO:
         * Вернуть после резолва таски https://jira.vk.team/browse/B2BCLOUD-1032
         * Вотчдог сейчас срабатывает раньше, чем ВКТ успевает отправить или
         * ответить нашему приложение, Решили пока ждать ответа максимально долго
         * или не загружать приложение
         */
        // new Promise((_resolve, reject) => setTimeout(() => reject(new Error('VKTeams not answering')), WAIT_RESPONSE_FROM_VKT_TIMEOUT)),
    ]);
}

export class VKTeamsClient {
    private static lastCall: Promise<unknown> = Promise.resolve();

    private constructor() {
        /* Decline manual creation  */
    }

    static applyAppThemeSettings() {
        if (!IS_MY_TEAM) {
            return VKTeamsClient;
        }

        VKTeamsClient.lastCall = VKTeamsClient.lastCall.then(() => {
            return sendVKTeamsMessageWithReliableAnswer<VKTColorScheme>(VKTeamsMessages.GetThemeSettings, {})
                .then(({ colorsScheme }) => {
                    if (colorsScheme === 'dark') {
                        const resumeTransitionEffects = preventTransitionEffects();
                        document.body.classList.add('vkui--cloud--dark');
                        resumeTransitionEffects();
                    }
                })
                .catch((error: Error) => {
                    console.error(error.message);
                });
        });

        return VKTeamsClient;
    }

    static notifyAppReady(isReady: boolean) {
        if (!IS_MY_TEAM) {
            return VKTeamsClient;
        }

        VKTeamsClient.lastCall = VKTeamsClient.lastCall.then(() => {
            return sendVKTeamsMessageWithReliableAnswer(VKTeamsMessages.LoadingCompleted, { ok: isReady })
                .catch((error: Error) => {
                    console.error(error.message);
                })
                .finally(() => {
                    window.ContentLoader?.setVKTClientLoaded?.();
                });
        });

        return VKTeamsClient;
    }
}
